<template>
	<div class="searchBox">
		<navbarSearch class="navBar" @searchBtn="searchBtn" :focus="inputFocus" :placeholderValS="placeholders" :searchVals="searchVals" />
		<div style="height: 1px; background: #f0f2f5"></div>
		<SearchHis :history-list="historyList" @clear-his="clearHis" @del="delHis" @search="searchText" />
		<SearchHot v-if="hotWords.length > 0" :hot-words="hotWords" @click-item="productBtn" />
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { jumpTo } from '@/utils/mateUrl.js';
import { mobileSpecialDetailPath } from '@/utils/link/mobileSpecialDetail';
import { getHotWordListNoLogin } from '@/api/index.js';
import NavbarSearch from '@/components/navbarSearch/index.vue';
import SearchHis from './components/SearchHis.vue';
import SearchHot from './components/SearchHot.vue';
import { getStorageSync, setStorageSync, removeStorageSync } from '@/utils/storage.js';
import { useIsGxzzSite } from '@/composables/useIsGxzzSite';
import { setIsGxzzSession } from '@/utils/gxzz';

const route = useRoute();
const router = useRouter();

const SEARCH_HISTORY_KEY = 'SEARCH_HISTORY';

const companyId = ref(route.query.companyId ?? '');
const placeholders = ref(route.query.placeholders ?? '产品名称/型号规格/厂家/商品描述');
const searchVals = ref(route.query.keyword ?? '');
const hotWords = ref([]);
const type = ref(route.query.type ?? '');
const id = ref(route.query.id ?? '');
const inputFocus = ref(false);
const productnature = ref(route.query.productnature ?? null);
const firstcategory = ref(route.query.firstcategory ?? '');
const secondcategory = ref(route.query.secondcategory ?? '');
const thirdcategory = ref(route.query.thirdcategory ?? '');
const historyList = ref([]);
const isGxzzSite = useIsGxzzSite(companyId);

useSeoMeta({
	title: '国械在线-搜索',
	ogTitle: '国械在线-搜索',
	ogImage: 'https://uat-cmdc.oss-cn-beijing.aliyuncs.com/productFile/2022/08/18/9af2756f-27bf-4d1e-b0d1-8397e82bb2a0.png',
});

function goBack() {
	router.back();
}

function getHistory() {
	try {
		if (import.meta.client) {
			const stored = getStorageSync(SEARCH_HISTORY_KEY);
			historyList.value = Array.isArray(stored) ? stored : [];
		}
	} catch {
		historyList.value = [];
	}
}

function modifyHistory() {
	if (import.meta.client) {
		setStorageSync(SEARCH_HISTORY_KEY, historyList.value || []);
	}
}

function searchBtn(val, opts = {}) {
	const { hotWordsId, searchType = 1 } = opts;
	if (!val?.trim()) {
		return;
	}
	searchVals.value = val.trim();
	historyList.value = historyList.value.filter(item => item !== val);
	historyList.value.unshift(val);
	historyList.value = historyList.value.slice(0, 25);
	modifyHistory();

	if (type.value === 'specialDetail') {
		const specialPath = mobileSpecialDetailPath(id.value);
		if (!specialPath) return;
		setIsGxzzSession(Boolean(companyId.value && companyId.value !== '1' && isGxzzSite.value));
		navigateTo({
			path: specialPath,
			query: { keyWord: val },
		});
		return;
	}
	if (type.value === 'clivee') {
		navigateTo({ path: '/pages/clivee/clivee', query: { keyword: val } });
		return;
	}

	const query = {
		keyword: val,
		placeholders: placeholders.value,
		companyId: companyId.value || '1',
		productnature: productnature.value ?? '',
		firstcategory: firstcategory.value,
		secondcategory: secondcategory.value,
		thirdcategory: thirdcategory.value,
		searchType,
	};
	if (hotWordsId) {
		query.hotWordsId = hotWordsId;
	}
	const targetPath =
		companyId.value && companyId.value !== '1' && isGxzzSite.value ? `/${companyId.value}/search` : '/productList';

	navigateTo({
		path: targetPath,
		query,
		replace: true,
	});
}

function searchHotList(companyIdVal) {
	getHotWordListNoLogin({
		companyId: companyIdVal,
		terminalType: 0,
	}).then(res => {
		if (res.code == 200) {
			hotWords.value = res.data || [];
		}
	});
}

function searchText(text) {
	searchVals.value = text;
	searchBtn(searchVals.value);
}

function delHis(item, index) {
	const idx = typeof index === 'number' ? index : historyList.value.indexOf(item);
	if (idx >= 0) {
		historyList.value.splice(idx, 1);
		modifyHistory();
	}
}

function clearHis() {
	historyList.value = [];
	removeStorageSync(SEARCH_HISTORY_KEY);
}

function productBtn(item) {
	const { clickType, linkUrlMobile, hotWordsId } = item;
	if (clickType === 1) {
		if (linkUrlMobile) jumpTo(linkUrlMobile);
	} else {
		searchVals.value = item.hotWords;
		searchBtn(searchVals.value, { searchType: 2, hotWordsId });
	}
}

onMounted(() => {
	placeholders.value = route.query.placeholders ?? '产品名称/型号规格/厂家/商品描述';
	searchVals.value = route.query.keyword ?? '';
	type.value = route.query.type ?? '';
	id.value = route.query.id ?? '';
	productnature.value = route.query.productnature ?? null;
	firstcategory.value = route.query.firstcategory ?? '';
	secondcategory.value = route.query.secondcategory ?? '';
	thirdcategory.value = route.query.thirdcategory ?? '';
	companyId.value = route.query.companyId ?? '';
	if (companyId.value && companyId.value !== 'undefined') {
		searchHotList(companyId.value);
	}
	getHistory();
	setTimeout(() => {
		inputFocus.value = true;
	}, 100);
});
</script>

<style lang="scss" scoped>
.searchBox {
	height: 100vh;
	background-color: #fff;

	.hotTopc {
		margin: 1rem 0 1rem 1.67rem;
		font-size: 1.17rem;
		font-family: NotoSansSC-Medium, NotoSansSC;
		font-weight: 500;
		color: #303133;
	}

	.hotTopcTitleList {
		display: flex;
		flex-wrap: wrap;
		margin-left: 1.67rem;
		align-items: center;

		.hotTopcTitle {
			padding: 0.5rem 1rem;
			border-radius: 0.17rem;
			background: #f3f4f6;
			margin-right: 1rem;
			margin-bottom: 1rem;
			font-size: 1rem;
			font-family: NotoSansSC-Regular, NotoSansSC;
			font-weight: 400;
			color: #606266;
		}
	}
}

.navBar {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	background: #fff;
	.search-input {
		flex: 1;
		height: 32px;
		padding: 0 10px;
		border: 1px solid #eee;
		border-radius: 6px;
		font-size: 14px;
	}
	.search-btn {
		padding: 0 12px;
		height: 32px;
		background: #455bd9;
		color: #fff;
		border: none;
		border-radius: 6px;
		font-size: 14px;
		cursor: pointer;
	}
	.back-icon {
		cursor: pointer;
		flex-shrink: 0;
	}
}
</style>
